export const toggleSidebar = ({ commit }, data) => {
  commit('TOGGLE_SIDEBAR', data)
}
